import { makeStyles } from '@material-ui/core/styles';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { fontSize } from '../../../../styles/themes/vad/font';

const useStyles = makeStyles(theme => {
  const { right, left, paddingLR } = theme.mixins;
  return {
    inputRoot: {
      paddingTop: pxToRem(16),
      paddingBottom: pxToRem(16),
      [theme.breakpoints.up('lg')]: {
        paddingTop: pxToRem(62),
        paddingBottom: pxToRem(59),
      },
    },
    CTAButton: {
      position: 'absolute',
      ...right(0),
      top: pxToRem(22),
      [theme.breakpoints.up('lg')]: {
        top: pxToRem(5),
      },
      '& .MuiButton-endIcon': {
        width: pxToRem(40),
        height: pxToRem(40),
        position: 'relative',

        [theme.breakpoints.up('lg')]: {
          width: pxToRem(60),
          height: pxToRem(60),
        },
        ' & .MuiIcon-root': {
          [theme.breakpoints.up('lg')]: {
            width: pxToRem(32),
            height: pxToRem(32),
          },
        },
        '& .MuiSvgIcon-root': {
          [theme.breakpoints.down('md')]: {
            position: 'absolute',
            top: pxToRem(8),
            ...left(pxToRem(8)),
            width: pxToRem(25),
            height: pxToRem(25),
          },

          [theme.breakpoints.up('lg')]: {
            width: pxToRem(35),
            height: pxToRem(35),
          },
        },
      },
    },
    searchInput: {
      position: 'relative',

      '&.removeBorder': {
        '& fieldset': {
          '& .MuiFormControl-root': {
            '& input': {
              border: 'none',
            },
          },
        },
      },
      '& fieldset': {
        width: '100%',
        marginTop: pxToRem(18),
        [theme.breakpoints.up('lg')]: {
          marginTop: 0,
        },
        '& .MuiFormControl-root': {
          '& .MuiFormLabel-root': {
            top: '-999999px',
          },
          '& .MuiInputBase-root': {
            marginTop: 0,
            borderWidth: '0 0 1px 0',
            height: pxToRem(52),
            borderRadius: borderRadius.b0,
            ...paddingLR(0, pxToRem(56)),

            [theme.breakpoints.up('lg')]: {
              height: pxToRem(77),
              ...paddingLR(0, pxToRem(106)),
            },
            '& input': {
              ...paddingLR('0 !important', `${pxToRem(40)} !important`),
              fontSize: `${fontSize.s20Rem}  !important`,
              ...theme.mixins.borderRight(theme.borders.divider),
              borderRadius: borderRadius.b0,

              [theme.breakpoints.up('lg')]: {
                fontSize: `${fontSize.s32Rem}  !important`,
                ...paddingLR('0 !important', `${pxToRem(64)} !important`),
              },
            },
            '&:hover': {
              background: theme.mixins.White(),
            },
            '& .MuiIconButton-label:after': {
              display: 'none',
            },
            '& .MuiAutocomplete-endAdornment': {
              '& .MuiAutocomplete-clearIndicator': {
                visibility: 'visible',
                '& .MuiIconButton-label': {
                  top: '-5px',
                  ...right(pxToRem(79)),

                  [theme.breakpoints.up('lg')]: {
                    top: pxToRem(-12),
                    ...right(pxToRem(153)),
                  },
                  '& .MuiSvgIcon-root': {
                    width: pxToRem(25),
                    height: pxToRem(25),
                  },
                },
              },
            },
          },
        },
        '& .MuiAutocomplete-popperDisablePortal': {
          top: pxToRem(52),

          [theme.breakpoints.up('lg')]: {
            top: pxToRem(77),
          },
        },
        '& .MuiPaper-root': {
          borderRadius: borderRadius.b0,
          boxShadow: theme.shadows[6],

          '& .MuiAutocomplete-listbox': {
            height: 'auto',
            margin: 0,
            padding: 0,
            border: 'none',

            '& .MuiAutocomplete-option': {
              padding: `${pxToRem(16)} ${pxToRem(24)}`,

              [theme.breakpoints.up('lg')]: {
                padding: `${pxToRem(16)} ${pxToRem(32)}`,
              },
              '&:after': {
                display: 'none',
              },
            },
          },
        },
      },
    },
  };
});

export default useStyles;
